import { render, staticRenderFns } from "./training-pc.vue?vue&type=template&id=98dd4cbc&"
import script from "./training-pc.vue?vue&type=script&lang=js&"
export * from "./training-pc.vue?vue&type=script&lang=js&"
import style0 from "./training-pc.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports